module.exports = __webpack_public_path__ + "img/vu.vuf55d435.svg";